export const MenuIcon = () => (
  <svg className="mc-icon-svg" xmlns="http://www.w3.org/2000/svg" width="30px" height="21px" viewBox="0 0 30 21">
    <g>
      <rect y="18" fillRule="evenodd" clipRule="evenodd" fill="#5D5E5E" width="30" height="3" />
      <rect fillRule="evenodd" clipRule="evenodd" fill="#5D5E5E" width="30" height="3" />
      <rect y="9" fillRule="evenodd" clipRule="evenodd" fill="#5D5E5E" width="30" height="3" />
    </g>
  </svg>
);
